export default "__VITE_ASSET__CEV_XcPD__"